import MergedChannels from "./MergedChannels";
import ReorderButtons from "./ReorderButtons";
import ImageChannelsStack from "./ImageChannelsStack";
import SingleChannelRow from "./SingleChannelRow";
import MergeChannelRow from "./MergeChannelRow";
import ImagePreview from "./ImagePreview";
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';


export default function ChannelImageRow(props){

  let {
    setTemplateEvals,
    channel,
    channels,
    channelId,
    templateEvals,
    onEvent,
    imageId,
    channelIndex,
    focusedImageId,
    accept=false,
  } = props;

  const IMAGE_WIDTH = 70;
  console.log(channels);

  let resolvedChannel = {
    ...templateEvals[channelIndex],
    ...channel,
  }
  //let { merge, colors } = channel;
  //let isMerge = (merge || colors?.length > 1);


 
  let moveUpDown = <ReorderButtons {...{
    onEvent,
    channelIndex,
    channels,
  }}/>
  

  let resolvedIuId = channel.imageId;// isMerge ? "MERGE_CHANNEL_"+channelId : imageId;

  let itemToView = imageId && (
    <ImagePreview width={"100%"} imageId={imageId}/>
  )
  /*; 
  if( true ){
    itemToView = ;
  }else{

    /*
    itemToView = <MergedChannels {...{
      merge, 
      channels,
      templateEvals
    }}/>
   
   */


  let row = <SingleChannelRow {...{...props,
    channel:resolvedChannel,
    channelId:Object.keys(channels)[channelIndex],itemToView,}}/>

  return (

    <tr onClick={e => {

      resolvedIuId && onEvent({type:"view",
          itemToView,
          imageId:resolvedIuId
      });

      //;

    }} class={
      resolvedIuId && (
        resolvedIuId === focusedImageId && 'selected-item-bg'
      )
      }
      style={{height:IMAGE_WIDTH}}>
    {row}
    {moveUpDown}
    </tr>


  )



}
